<div class="container mt-3">
    <div class="cssmtgb just_center">
        <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
        (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Payment Arrangement">
                <div class="container mt-3">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Payment Arrangement</span>

                        </div>
                    </div>
                    <div class="card card_content">
                        <form [formGroup]="form">
                            <div class="row mt-3">
                                <div class="col-xl-3 d-none d-md-block">
                                </div>
                                <div class="col-xl-5 padd-right-file" style="display: flex;">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'searchText-mat-field'" >
                                        <mat-label>Search</mat-label>
                                        <div class="search-input-container">
                                            <input formControlName="searchQuery" placeholder="Enter Refernce Number"
                                                id="search" matInput type="text" #searchInput>
                                        </div>
                                    </mat-form-field>
                                    <button matSuffix mat-icon-button aria-label="Search"
                                        class="badge bg-light-blue image-button" (click)="search('arrangement')">
                                        <mat-icon style="color: white;">search</mat-icon>
                                    </button>
                                </div>
                                <button type="button" class="btn reset_btn"  (click)="clearFilter()">
                                    <i class="fa fa-refresh"></i> Reset
                                </button>
                            </div>
                        </form>

                        <div class="table-responsive table-container mt-2 mb-4" *ngIf="showtable">
                            <mat-table #table [dataSource]="dataSource" class="mat-table ">

                                <ng-container matColumnDef="FNO">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;">FNO</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                        <p class="text-truncate txtalign"> {{dataField.providerName}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Application">
                                    <mat-header-cell *matHeaderCellDef style="text-align: center;">
                                        Application</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.referenceNumber}} </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Customer">
                                    <mat-header-cell *matHeaderCellDef
                                        style="text-align: center;">Customer</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%; text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.customerNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Name">
                                    <mat-header-cell *matHeaderCellDef
                                        style="text-align: center;">Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.name}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Contact">
                                    <mat-header-cell *matHeaderCellDef
                                        style="text-align: center;">Contact</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                        <p class="text-truncate txtalign">{{dataField.mobileNumber}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Address">
                                    <mat-header-cell *matHeaderCellDef
                                        style="margin:0;padding:0">Address</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 15%;text-align: center;">
                                        <p class="text-truncate txtalign">R {{dataField.address}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="ApplicationStatus">
                                    <mat-header-cell *matHeaderCellDef>Application Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField" style="width: 10%;text-align: center;">
                                        <p class="text-truncate txtalign">R {{dataField.applicationStatus}}</p>
                                    </mat-cell>
                                </ng-container>


                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                                </mat-row>
                            </mat-table>
                            <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>
               


                        <div class="d-flex justify-content-end button-style mt-3"
                            *ngIf="showtable&& dataSource.data.length>0">
                            <button class="btn btn-primary mb-3 mr-3" type="button" (click)="save('arangement')"
                                matButton> <i class="fa fa-money-bill"></i>
                                Payment Arrangement</button>
                    
                        </div>
                    </div>
                </div>
                </mat-tab>

                <mat-tab label="Revoke Arrangement">
                    <div class="container mt-3">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar">Revoke Payment Arrangement</span>
    
                            </div>
                        </div>
                        <div class="card card_content">
                            <form [formGroup]="form">
                                <div class="row mt-3">
                                    <div class="col-xl-3 d-none d-md-block">
                                    </div>
                                    <div class="col-xl-5 padd-right-file" style="display: flex;">
                                        <mat-form-field appearance="fill" hideRequiredMarker
                                            [ngClass]="'searchText-mat-field'" >
                                            <mat-label>Search</mat-label>
                                            <div class="search-input-container">
                                                <input formControlName="searchQuery" placeholder="Enter Refernce Number"
                                                    id="search" matInput type="text" #searchInput>
                                            </div>
                                        </mat-form-field>
                                        <button matSuffix mat-icon-button aria-label="Search"
                                            class="badge bg-light-blue image-button" (click)="search('revoke')">
                                            <mat-icon style="color: white;">search</mat-icon>
                                        </button>
                                    </div>
                                    <button type="button" class="btn reset_btn" (click)="clearFilter()">
                                        <i class="fa fa-refresh"></i> reset
                                    </button>
                                </div>
                            </form>
    
                            <div class="table-responsive table-container mt-2 mb-4" *ngIf="showtable">
                                <mat-table #table [dataSource]="dataSource" class="mat-table ">
    
                                    <ng-container matColumnDef="FNO">
                                        <mat-header-cell *matHeaderCellDef style="text-align: center;">FNO</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                            <p class="text-truncate txtalign"> {{dataField.providerName}}</p>
                                        </mat-cell>
                                    </ng-container>
    
                                    <ng-container matColumnDef="Application">
                                        <mat-header-cell *matHeaderCellDef style="text-align: center;">
                                            Application</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.referenceNumber}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Customer">
                                        <mat-header-cell *matHeaderCellDef
                                            style="text-align: center;">Customer</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%; text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.customerNumber}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Name">
                                        <mat-header-cell *matHeaderCellDef
                                            style="text-align: center;">Name</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.name}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Contact">
                                        <mat-header-cell *matHeaderCellDef
                                            style="text-align: center;">Contact</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                            <p class="text-truncate txtalign">{{dataField.mobileNumber}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Address">
                                        <mat-header-cell *matHeaderCellDef
                                            style="margin:0;padding:0">Address</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 15%;text-align: center;">
                                            <p class="text-truncate txtalign">R {{dataField.address}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="ApplicationStatus">
                                        <mat-header-cell *matHeaderCellDef>Application Status</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField" style="width: 10%;text-align: center;">
                                            <p class="text-truncate txtalign">R {{dataField.applicationStatus}}</p>
                                        </mat-cell>
                                    </ng-container>
    
    
                                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
    
                                    <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                                    </mat-row>
                                </mat-table>
                                <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                                    <p>No data found</p>
                                </div>
                            </div>
 
    
    
                            <div class="d-flex justify-content-end button-style mt-3"
                                *ngIf="showtable&& dataSource.data.length>0">
                                <button class="btn btn-primary mb-3" type="button" (click)="save('revoke')" matButton>
                                    <i class="fa fa-money-bill"></i> Revoke Arrangement</button>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                </mat-tab-group>